// TSS vite/03 §"Query keys convention".

export const animalKeys = {
    all:    ['animals'],
    list:   (filters) => ['animals', 'list', filters],
    infinite: (filters, limit) => ['animals', 'list', 'infinite', filters, limit],
    detail: (id)      => ['animals', 'detail', id],
    owners: (id)      => ['animals', 'owners', id],
    valuations: (id)  => ['animals', 'valuations', id],
    farmMoves: (id)   => ['animals', 'farm-moves', id],
    opuBreakdown: (id) => ['animals', 'opu-breakdown', id],
};
